<div class="doc-block">
  <div class="doc-delete">
    <app-round-checkbox [extraClass]="'small bg-white'" [id]="document.docId" [isSelected]="document.selection.isSelected" (click)="selectByClick()"></app-round-checkbox>
  </div>
  <div class="doc-item" [classList]="document.selection.isSelected ? 'doc-item selected' : 'doc-item not-selected'">
    <img src="./assets/ui/svg/blue/text-icon.svg" class="doc-item-icon">
    <div class="doc-item-name">
      <span class="file-name">{{document.name | slice:0:20}}</span>
      <span class="file-size">{{document.uploadedAt | currentDateTime}} | {{document.size | fileSize }}</span>
      <app-progress-bar *ngIf="document.status=='processing' || document.status=='uploaded'" [progress]="document.progress"></app-progress-bar>
    </div>
    <div class="doc-item-buttons" *ngIf="!document.selection.selectionMode">
      <a [routerLink]="['/document',document.docId]" *ngIf="document.status=='anonymised'" @item><img src="./assets/ui/svg/blue/Edit-icon.svg"></a>
      <a (click)="share()" *ngIf="document.status=='anonymised'" @item><img src="./assets/ui/svg/blue/share-icon.svg"></a>
      <a (click)="download()" *ngIf="document.status=='anonymised'" @item><img src="./assets/ui/svg/blue/Download-icon.svg"></a>
      <a *ngIf="document.status=='error'" matTooltip="An unknown error has occurred." @item><img src="./assets/ui/svg/red/alert.svg"></a>
      <app-spinnig-infinity-loader *ngIf="document.status=='processing' || document.status=='uploaded'" [matTooltip]="document.progress + ' %'" @item></app-spinnig-infinity-loader>
    </div>

</div>
